
import { defineComponent, computed, onMounted, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { IStoreType } from '@/store/types'
import { IarchivesType } from '@/store/page-file/types'
import '@/assets/font/iconfont'
import { useRouter } from 'vue-router'
export default defineComponent({
  props: {
    isRequest: {
      type: Boolean
    }
  },
  setup(props) {
    const store = useStore<IStoreType>()
    const categoryList = computed(() => {
      return store.state.pageFileModule.category
    })
    // 数据优化
    let category = ref<IarchivesType[]>([])
    let optimize = (lists: IarchivesType[]) => {
      let res: IarchivesType[] = Object.values(lists).flat(Infinity)
      category.value = res
        .sort((a, b): any => {
          if (typeof b.read === 'number' && typeof a.read === 'number') {
            return b.read - a.read
          }
        })
        .slice(0, 8)
    }
    watch(categoryList, (n) => {
      optimize(n)
    })
    onMounted(() => {
      if (!Object.keys(categoryList.value).length && props.isRequest) {
        // 调用初始数据接口
        store.dispatch('pageFileModule/onFile')
      } else {
        console.log(typeof categoryList.value)
        optimize(categoryList.value)
      }
    })
    // 跳转页面
    const router = useRouter()
    const onRouter = (_id: string) => {
      let routeUrl = router.resolve({
        path: `details`,
        query: { id: _id }
      })
      window.open(routeUrl.href, '_blank')
    }
    return {
      category,
      onRouter
    }
  }
})
